// extracted by mini-css-extract-plugin
module.exports = {"video":"Home_video__2JEYk","main":"Home_main__JZ_n1"};